export const UNKNOWN_TENANT = 'Unknown Tenant';
